import { render } from "./ActionButton.vue?vue&type=template&id=25c37b85&scoped=true"
import script from "./ActionButton.vue?vue&type=script&lang=ts"
export * from "./ActionButton.vue?vue&type=script&lang=ts"

import "./ActionButton.vue?vue&type=style&index=0&id=25c37b85&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25c37b85"

export default script